import { useContext } from 'react'

import { AuthContext } from 'features/auth/auth-context'
import { canShareWith } from 'features/share/can-share-with'
import { useShareAllowlistQuery } from 'features/share/hooks/use-share-allowlist-query'
import type { ShareService } from 'features/share/service'

const NO_DOMAINS: string[] = []

/** Returns a predicate: may the current user share with `targetEmail`? */
export function useCanShareWith(
  service: ShareService,
  projectId: string,
): (targetEmail: string) => boolean {
  const { userDetails } = useContext(AuthContext)
  const { data: allowedDomains = NO_DOMAINS } = useShareAllowlistQuery(
    service,
    projectId,
  )
  const inviterEmail = userDetails?.email ?? ''
  return (targetEmail) =>
    canShareWith(inviterEmail, targetEmail, allowedDomains)
}
